module.exports = __webpack_public_path__ + "static/dcom3-150x150-6d433c47db3115e211649e065e610a86.png";